module.exports = __webpack_public_path__ + "static/media/weight-hanging.a3fd9374.svg";